import { QRCodeSVG } from 'qrcode.react';

const BASE_URL = 'https://mikkel-kviss.web.app';

export default function QRCode({ sessionId, size = 200, lightText = false, joinPath = '/join' }) {
  if (!sessionId) return null;
  const joinUrl = `${BASE_URL}${joinPath}?session=${sessionId}`;

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="bg-white p-4 rounded-xl shadow-lg">
        <QRCodeSVG
          value={joinUrl}
          size={size}
          level="M"
          includeMargin={false}
        />
      </div>
      <p className={`text-sm text-center max-w-xs ${lightText ? 'text-white/80' : 'text-gray-500'}`}>
        Skann QR-koden for å bli med
      </p>
    </div>
  );
}
